import React, { Component } from "react";
import { Link } from "react-router-dom";

import Header from "../component/Header";
import BottomNav from "../component/BottomNav";

import BookScrollList from "../component/BookScrollList";
import BookRank from "../component/BookRank";
import BookGrid from "../component/BookGrid";

//import { browserHistory } from 'react-router'

import "../scss/style.scss";
import queryString from 'query-string';
import cookie from 'react-cookie';
import Slider from 'react-animated-slider';
import '../scss/horizontal.css';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-125086411-4');

function getOS() {
    var userAgent = window.navigator.userAgent,
            platform = window.navigator.platform,
            macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
            windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
            iosPlatforms = ['iPhone', 'iPad', 'iPod'],
            iphonePlatforms = ['iPhone','iPod'],
            ipadPlatforms = ['iPad'],
            os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
        if(userAgent.indexOf("iPad;")>-1) os = 'iPad';
    } else if (ipadPlatforms.indexOf(platform) !== -1) {
        os = 'iPad';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
    } else if (/Android/.test(userAgent)) {
        os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
    }

    return os;
}


function jump_audiobook_home() {
    var qs= cookie.load("initial_querystring");
    let signin_url="/HomeAudioBook"+qs;
    //console.log("new home url "+signin_url);
    //props.history.push(signin_url);
    //props.history.replace(signin_url);
    window.location.href=signin_url;
}



function  no_pull_refresh () {
    var touchStartHandler,
        touchMoveHandler,
        touchPoint;

    // Only needed for touch events on chrome.
    if ((window.chrome || navigator.userAgent.match("CriOS")) && "ontouchstart" in document.documentElement || true) {

        touchStartHandler = function(event) {
            // Only need to handle single-touch cases
            touchPoint = event.touches.length === 1 ? event.touches[0].clientY : null;
        };

        touchMoveHandler = function(event) {
            var newTouchPoint;

            // Only need to handle single-touch cases
            if (event.touches.length !== 1) {
                touchPoint = null;

                return;
            }

            // We only need to defaultPrevent when scrolling up
            newTouchPoint = event.touches[0].clientY;
            if (newTouchPoint > touchPoint) {
                event.preventDefault();
        }
        touchPoint = newTouchPoint;
    };

    document.addEventListener("touchstart", touchStartHandler, {
        passive: false
    });

    document.addEventListener("touchmove", touchMoveHandler, {
        passive: false
    });

}
}

if(false) {
    var target = window; // this can be any scrollable element
    var last_y = 0;
    target.addEventListener('touchmove', function(e){
        var scrolly = target.pageYOffset || target.scrollTop || 0;
        var direction = e.changedTouches[0].pageY > last_y ? 1 : -1;
        if(direction>0 && scrolly===0){
            e.preventDefault();
        }
        last_y = e.changedTouches[0].pageY;
    });
};

var DEBUG=true;
//var DEBUG=false;





class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            headerTitle: "더책",
            self: this, aaa: props,
            loading: true, noback: true, suggest: [],
            servicetype:20 
        };
        if(props.match.params.servicetype!=null) {
            this.state.servicetype= parseInt(props.match.params.servicetype);
        }
        //this.props.history = []; //.push('/');

        //this.props.history.push("/");
        //this.props.history.replace('', null);

        //browserHistory.replace('/');

        //alert(JSON.stringify(this.props));     

        var qs = window.location.search;
        if(qs===undefined || qs==="" || qs===null) {
            qs=cookie.load("initial_querystring");
            if(qs===undefined || qs==="" || qs===null) {
                qs= "?device_userid=967dbb95-6a1e-4cbc-bdae-6f5df66f24e4&device_password=B716A34E-95F9-48CA-AF57-9FD65DEFD05A&device_model=WEBTEST&device_os=14.0.1&app_version=2.0.0";
            }
        };
        let params = queryString.parse(qs);
        this.setCookie_QS(qs);
        this.setCookie_app(params);
        if(DEBUG) console.log("this is /Home");
        if(DEBUG) console.log(window.location.href);
        //alert(window.location.href+JSON.stringify(params));
        if(DEBUG) console.log(params);

        let struserid = cookie.load("userid");
        let struserdbid = cookie.load("userdbid");
        let device_struserid = cookie.load("device_userid");
        let device_struserdbid = cookie.load("device_userdbid");
        let general_struserid = cookie.load("general_userid");
        let general_struserdbid = cookie.load("general_userdbid");
        if(DEBUG) console.log("cookie userid: " + struserid);
        if(DEBUG) console.log("cookie userdbid: " + struserdbid);
        if(DEBUG) console.log("cookie device_userid: " + device_struserid);
        if(DEBUG) console.log("cookie device_userdbid: " + device_struserdbid);
        if(DEBUG) console.log("cookie general_userid: " + general_struserid);
        if(DEBUG) console.log("cookie general_userdbid: " + general_struserdbid);

        if(general_struserid!==undefined && general_struserid.length>36) {
            this.removeCookie_only_general();
            general_struserid = cookie.load("general_userid");
            general_struserdbid = cookie.load("general_userdbid");
        }

        if(struserid!==undefined && device_struserid!==undefined) { 
            if(struserid===device_struserid) { 
                if(struserid.length < 36) { //logout general user except for device_user
                    this.removeCookie();
                    struserid= undefined;
                    struserdbid= undefined;
                } else {
                    //good do nothing!
                };
            } else {
                this.removeCookie();
                this.copy_device_cookie_to_cookie();
                struserid= device_struserid;;
                struserdbid= device_struserdbid;;
            };
        } else 
        if(struserid!==undefined && device_struserid===undefined) { 
            if(struserid.length < 36) { //logout general user except for device_user
                this.copy_cookie_to_general_cookie();
                this.removeCookie();
                struserid= undefined;
                struserdbid= undefined;
            } else {
                //good do nothing!
                this.copy_cookie_to_device_cookie();
            };
        } else 
        if(struserid===undefined && device_struserid!==undefined) { 
            if(device_struserid.length < 36) { //logout general user except for device_user
                // no logon cookie
            } else {
                this.copy_device_cookie_to_cookie();
                struserid= device_struserid;;
                struserdbid= device_struserdbid;;
            };
        } else 
        if(struserid===undefined && device_struserid===undefined) { 
                // no logon cookie
        };

        let struserid2 = cookie.load("userid");
        let struserdbid2 = cookie.load("userdbid");
        let device_struserid2 = cookie.load("device_userid");
        let device_struserdbid2 = cookie.load("device_userdbid");
        let general_struserid2 = cookie.load("general_userid");
        let general_struserdbid2 = cookie.load("general_userdbid");
        if(DEBUG) console.log("!cookie userid: " + struserid2);
        if(DEBUG) console.log("!cookie userdbid: " + struserdbid2);
        if(DEBUG) console.log("!cookie device_userid: " + device_struserid2);
        if(DEBUG) console.log("!cookie device_userdbid: " + device_struserdbid2);
        if(DEBUG) console.log("!cookie general_userid: " + general_struserid2);
        if(DEBUG) console.log("!cookie general_userdbid: " + general_struserdbid2);


            //alert(struserid + ",," + struserdbid+" ... "+qs);
        if (params != null && 
            params.device_userid !== undefined && params.device_password !== undefined &&
            struserid === undefined && struserdbid === undefined) {
                var arg = {
                    type: 9, //device_user type
                    orgid: 20, // anonymouse group
                    //userid: params.device_userid,
                    userid: params.device_model + "," + params.device_userid,
                    passwd: params.device_password
                };
                if(DEBUG) console.log(arg);
                fetch(`/api/AB/dologin`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(arg)
                })
                    .then(response => response.json())
                    .then(data => {
                        if(data.R.RC!=250)
                            if (DEBUG) console.log("1");
                        //console.table(data);
                        //console.dir(data);
                        if (data.R.RC === 250) {
                            if(DEBUG) console.log("device_user login success");
                            this.state.self.setCookie_THECHAEK(
                                data.dicresult.userinfo.userid,
                                data.dicresult.userinfo.id,
                                data.dicresult.userinfo.orgid,
                                data.dicresult.userlogoncount,
                                data.dicresult.userlendcount,
                                data.dicresult.userinfo.org.orgname,
                                data.dicresult.sbc
                            );

				let struserid = cookie.load("userid");
				let struserdbid = cookie.load("userdbid");
				let device_struserid = cookie.load("device_userid");
				let device_struserdbid = cookie.load("device_userdbid");
				let general_struserid = cookie.load("general_userid");
				let general_struserdbid = cookie.load("general_userdbid");
				if(DEBUG) console.log("!!!cookie userid: " + struserid);
				if(DEBUG) console.log("!!!cookie userdbid: " + struserdbid);
				if(DEBUG) console.log("!!!cookie device_userid: " + device_struserid);
				if(DEBUG) console.log("!!!cookie device_userdbid: " + device_struserdbid);
				if(DEBUG) console.log("!!!cookie general_userid: " + general_struserid);
				if(DEBUG) console.log("!!!cookie general_userdbid: " + general_struserdbid);

                            let orgid = cookie.load("orgid");
                            if (typeof orgid === 'undefined')
                                orgid = -1;

                            fetch('/api/AB/GetOrgInfo?orgid=' + orgid)
                                .then(response => response.json())
                                .then(data => {
                                    if (DEBUG) console.log("2");
                                    //console.log("ORGINFO");
                                    //console.log(data);
                                    this.setState({ ...this.state, loading: false, suggest: data.lstresult });
                                });
                        }
                        else {
                            if (DEBUG) console.log("3");
                            if(DEBUG) console.log("device_user login failure");
                        }
                    });
        } else {
                            let orgid = cookie.load("orgid");
                            if (typeof orgid === 'undefined')
                                orgid = -1;

                            fetch('/api/AB/GetOrgInfo?orgid=' + orgid)
                                .then(response => response.json())
                                .then(data => {
                                    if(DEBUG) console.log("ORGINFO");
                                    if (DEBUG) console.log(data);
                                    if (DEBUG) console.log("4");
                                    this.setState({ ...this.state, loading: false, suggest: data.lstresult });
                    });

                    }
                    };

componentDidMount() {
            //no_pull_refresh();
                        window.addEventListener('orientationchange',function() {
                        console.log("*** ORIENT CHANGE: ");
            });
    };


setCookie1(orgid, orgname, rootpath) {
    let d = new Date();
    d.setTime(d.getTime() + (12 * 60 * 60 * 1000));
    cookie.save("orgid", orgid, { path: "/", expires: d });
    cookie.save("orgname", orgname, { path: "/", expires: d });
    cookie.save("root", rootpath, { path: "/", expires: d });
};
setCookie_app(params) {
    let d = new Date();
    d.setTime(d.getTime() + (12 * 60 * 60 * 1000));
    cookie.save("app_version", params["app_Version"], { path: "/", expires: d });
    cookie.save("device_os", params["device_os"], { path: "/", expires: d });
    cookie.save("device_model", params["device_model"], { path: "/", expires: d });
};

setCookie_THECHAEK(userid, strdbid, orgid, logoncount, llendbookcount, orgname, sbc) {
    let d = new Date();
    d.setTime(d.getTime() + (12 * 60 * 60 * 1000));
    cookie.save("userid", userid, { path: "/", expires: d });
    cookie.save("userdbid", strdbid, { path: "/", expires: d });
    cookie.save("orgid", orgid, { path: "/", expires: d });
    cookie.save("lc", logoncount, { path: "/", expires: d });
    cookie.save("lendc", llendbookcount, { path: "/", expires: d });
    cookie.save("orgname", orgname, { path: "/", expires: d });
    cookie.save("sbc", sbc, { path: "/", expires: d });
    cookie.save("device_userid", userid, { path: "/", expires: d });
    cookie.save("device_userdbid", strdbid, { path: "/", expires: d });
    cookie.save("device_orgid", orgid, { path: "/", expires: d });
    cookie.save("device_lc", logoncount, { path: "/", expires: d });
    cookie.save("device_lendc", llendbookcount, { path: "/", expires: d });
    cookie.save("device_orgname", orgname, { path: "/", expires: d });
    cookie.save("device_sbc", sbc, { path: "/", expires: d });
    };

    
setCookie_AUDIOBOOK(userid, strdbid, orgid, logoncount, llendbookcount, orgname, sbc) {
    let d = new Date();
    d.setTime(d.getTime() + (12 * 60 * 60 * 1000));
    cookie.save("userid", userid, { path: "/", expires: d });
    cookie.save("userdbid", strdbid, { path: "/", expires: d });
    cookie.save("orgid", orgid, { path: "/", expires: d });
    cookie.save("lc", logoncount, { path: "/", expires: d });
    cookie.save("lendc", llendbookcount, { path: "/", expires: d });
    cookie.save("orgname", orgname, { path: "/", expires: d });
    cookie.save("sbc", sbc, { path: "/", expires: d });
    cookie.save("general_userid", userid, { path: "/", expires: d });
    cookie.save("general_userdbid", strdbid, { path: "/", expires: d });
    cookie.save("general_orgid", orgid, { path: "/", expires: d });
    cookie.save("general_lc", logoncount, { path: "/", expires: d });
    cookie.save("general_lendc", llendbookcount, { path: "/", expires: d });
    cookie.save("general_orgname", orgname, { path: "/", expires: d });
    cookie.save("general_sbc", sbc, { path: "/", expires: d });
    };

    
removeCookie() {
    cookie.remove("userid", { path: '/' });
    cookie.remove("userdbid", { path: '/' });
    cookie.remove("orgid", { path: '/' });
    cookie.remove("lc", { path: '/' });
    cookie.remove("lendc", { path: '/' });
    cookie.remove("orgname", { path: '/' });
    cookie.remove("sbc", { path: '/' });
};

removeCookie_only_general() {
    cookie.remove("general_userid", { path: '/' });
    cookie.remove("general_userdbid", { path: '/' });
    cookie.remove("general_orgid", { path: '/' });
    cookie.remove("general_lc", { path: '/' });
    cookie.remove("general_lendc", { path: '/' });
    cookie.remove("general_orgname", { path: '/' });
    cookie.remove("general_sbc", { path: '/' });
};


removeCookie_device_complete(userid) {
    cookie.remove("userid", { path: '/' });
    cookie.remove("userdbid", { path: '/' });
    cookie.remove("orgid", { path: '/' });
    cookie.remove("lc", { path: '/' });
    cookie.remove("lendc", { path: '/' });
    cookie.remove("orgname", { path: '/' });
    cookie.remove("sbc", { path: '/' });
    cookie.remove("device_userid", { path: '/' });
    cookie.remove("device_userdbid", { path: '/' });
    cookie.remove("device_orgid", { path: '/' });
    cookie.remove("device_lc", { path: '/' });
    cookie.remove("device_lendc", { path: '/' });
    cookie.remove("device_orgname", { path: '/' });
    cookie.remove("device_sbc", { path: '/' });
};

removeCookie_general_complete(userid) {
    cookie.remove("userid", { path: '/' });
    cookie.remove("userdbid", { path: '/' });
    cookie.remove("orgid", { path: '/' });
    cookie.remove("lc", { path: '/' });
    cookie.remove("lendc", { path: '/' });
    cookie.remove("orgname", { path: '/' });
    cookie.remove("sbc", { path: '/' });
    cookie.remove("general_userid", { path: '/' });
    cookie.remove("general_userdbid", { path: '/' });
    cookie.remove("general_orgid", { path: '/' });
    cookie.remove("general_lc", { path: '/' });
    cookie.remove("general_lendc", { path: '/' });
    cookie.remove("general_orgname", { path: '/' });
    cookie.remove("general_sbc", { path: '/' });
};

copy_cookie_to_device_cookie() {
  this.setCookie_THECHAEK(
    cookie.load("userid"),
    cookie.load("userdbid"),
    cookie.load("orgid"),
    cookie.load("lc"),
    cookie.load("lendc"),
    cookie.load("orgname"),
    cookie.load("sbc")
  );
};

copy_cookie_to_general_cookie() {
  this.setCookie_AUDIOBOOK(
    cookie.load("userid"),
    cookie.load("userdbid"),
    cookie.load("orgid"),
    cookie.load("lc"),
    cookie.load("lendc"),
    cookie.load("orgname"),
    cookie.load("sbc")
  );
};

copy_device_cookie_to_cookie() {
  this.setCookie_THECHAEK(
    cookie.load("device_userid"),
    cookie.load("device_userdbid"),
    cookie.load("device_orgid"),
    cookie.load("device_lc"),
    cookie.load("device_lendc"),
    cookie.load("device_orgname"),
    cookie.load("device_sbc")
  );
};

copy_general_cookie_to_cookie() {
  this.setCookie_AUDIOBOOK(
    cookie.load("general_userid"),
    cookie.load("general_userdbid"),
    cookie.load("general_orgid"),
    cookie.load("general_lc"),
    cookie.load("general_lendc"),
    cookie.load("general_orgname"),
    cookie.load("general_sbc")
  );
};

setCookie_QS(initial_querystring) {
    let d = new Date();
    d.setTime(d.getTime() + (12 * 60 * 60 * 1000));
    cookie.save("initial_querystring", initial_querystring, { path: "/", expires: d });
};

    dorender() {
        let orgid = cookie.load("orgid");
        if (typeof orgid === 'undefined')
            orgid = 0;
      
        let st_suggest = [];
        let suggest = this.state.suggest;
        let suggestnumber;
        var bannertitle;

       if(DEBUG) console.log(this.state);
       if (typeof suggest != 'undefined') {
           for (let i = 0; i < suggest.length; i++) {
               suggestnumber = suggest[i].refsuggesttype;
               if (suggestnumber < 20) continue;

               if (suggestnumber === 21)
                   bannertitle = suggest[i].typedesc;

               let link_data=	{
                   pathname:"/BookListSuggest",
                   state:{
                       sgt:suggestnumber,
                       sw: '',
                       ow: 0,
                       ob: 2,
                       al: '',
                       st: 20,
                       lg: 0,
                       subtitle: suggest[i].typedesc
                   }
               };
               st_suggest.push(<div className="section-suggest">
                   <div className="section1-header-suggest">
                       <h2 className="section-title">
                           <Link to={link_data} >{suggest[i].typedesc}</Link>
                       </h2>
                       <div className="section-title-more-lsb2">
                           <Link to={link_data} className="section-title-more-lsb2-link"> 더보기 > </Link>
                       </div>
                   </div>
                   <div className="section-body-suggest">
                       <BookScrollList fetchurl={`/api/AB/BookListBySuggest?suggesttype=${suggestnumber}&pgsize=100&orderby=2&orderway=0&servicetype=${this.state.servicetype}`} />
                   </div>
               </div>)
                       }
                       }
           //<!--
           //<Link to="https://www.changbi.com/"><img src={"/assets/images/newimages/cbi_banner2.PNG"}/></Link>
           //<a target="_blank" rel="noopener noreferrer" href="https://www.changbi.com/"><img src={"/assets/images/newimages/cbi_banner1.PNG"}/></a>
           //-->

       var ios_safe_area="";
       if(getOS()==="iOS") {
           ios_safe_area=<div className="iphone-top-safe-area">&nbsp;</div>;
       }

       let slideA=   {
           title: '1 items',
           description: '1desc',
           url: {
               pathname: `/InfoView5`,
               state: {
                   title: '더책 서비스 안내',
                   url: 'http://old.thechaek.com/Mobile/NoticeView/1/77'
               }
           },
           image: '/assets/images/newimages/mcb_home_banner1.jpg',
           bgcolor:'#ffc600'
       };

       let slideB= {
           title: '2 item',
           description: '2desc',
           url: {
               pathname:"/Search",
               state:{
                   sgt:21,
                   sw: '',
                   ow: 0,
                   ob: 2,
                   al: '',
                   st: 20,
                   lg: 0,
                   subtitle: bannertitle
               }
           },
           image: '/assets/images/newimages/mcb_home_banner3.jpg',
           bgcolor: '#00AE67'
       };

      // 동일 슬아이드를 2번 반복하는 이유는 Slide 가 3개 이상들어가야 로테이트가 되기 때문 
       const slides = [
           slideB
        ];

       let cls= {
           slider: 'slider',
           previousButton: 'previousButton',
           nextButton: 'nextButton',
           buttonDisabled: 'disabled',
           track: 'track',
           slide: 'slide',
           hidden: 'hidden',
           previous: 'previous',
           current: 'current',
           next: 'next',
           animateIn: 'animateIn',
           animateOut: 'animateOut'
       };

       return (
           <React.Fragment>
               <Header headerTitle={this.state.headerTitle} subTitle={"더책"} />

<div className="section1-lsb-home-banner">
     <Slider clssNames={cls} autoplay={3000} infinite="true">
       {slides.map((slide, index) =>
                  <div key={index} className={'lsb-home-banner-slider-item'} >
                    <Link to={slide.url}><img src={slide.image} style={{backgroundColor: slide.bgcolor}} className={'lsb-home-slider-image'}/></Link>
                  </div>
           )}
      </Slider>
</div>

       {st_suggest}

               <div className="section">
                   <div className="section-header">
                       <h2 className="section-title">
                           <Link to="/cateview">전체 더책</Link>
                       </h2>
                       <div className="section-title-more">
                           <Link to="/cateview">전체 목록보기</Link>
                       </div>
                   </div>
                   <div className="section-body">
                       <BookScrollList fetchurl={"/api/AB/BookListR2?pgidx=0&pgsize=50&orderby=100&orderway=0&servicetype="+this.state.servicetype} />
                   </div>
               </div>
               <BottomNav />
           </React.Fragment>
       );
       }

   logPageView() {
       ReactGA.set({ page: window.location.pathname });
       ReactGA.pageview(window.location + "&orgid=" + cookie.load("orgid"));
       }

   render() {
        
        if(false)
        if( getOS()==='iPad') {
           setTimeout(jump_audiobook_home,5000);
           return (<div><p/><p/><p/><center><h3>태블릿은 더책 서비스 이용이 불가능합니다. </h3><p/><p/><p/><p/><h4>5 초후 오디오북 라이브러리로 이동합니다.</h4><p/><p/><p/>{window.navigator.userAgent}</center></div>);
       };

       let contents = this.state.loading === true
           ? <p className="section-description-lsb">Loading.....</p>
           : this.dorender(); 

       this.logPageView();

       return (
           <React.Fragment>
       {contents}
           </React.Fragment>
       );
       }
       }

export default Home;
